import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FullTable, AddCircleBlue } from 'components';
import { systemActions } from 'store';
import { sortListByKey, useModal } from 'utils';
import { CreateEditServiceType } from './modals/createEditServiceType';
import { systemTypeBody, systemTypeHead, ACTION_TYPE, systemNotYet } from './constants';

export const ServiceType = ({}) => {
    const globalServices = useSelector((state) => state.system.services);
    const dispatch = useDispatch();
    const location = useLocation();
    const pushInfo = location?.state;
    const { open } = useModal();

    const getServices = (noLoad) => {
        const loading = noLoad ? 'noLoad' : '';
        const sendInfo = {
            ...pushInfo,
        };
        delete sendInfo.page;
        delete sendInfo.activeTab;
        dispatch(systemActions.getServices(sendInfo, loading));
    };

    useEffect(() => {
        getServices();
    }, [pushInfo]);

    const handleClickButton = (info) => {
        open(<CreateEditServiceType info={info} afterSuccess={() => getServices(true)} />);
    };

    return (
        <div>
            <div className="header-action-btn">
                <AddCircleBlue
                    text={'Add Service Type'}
                    handleClick={() => open(<CreateEditServiceType afterSuccess={() => getServices(true)} />)}
                />
            </div>
            <FullTable
                head={systemTypeHead}
                body={systemTypeBody}
                loadingType={ACTION_TYPE}
                list={sortListByKey(globalServices?.serviceTypes, 'name')}
                handleClickButton={handleClickButton}
                notYet={systemNotYet}
                margin={'16px 0 0 0'}
            />
        </div>
    );
};
